/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, ReactNode } from "react";

interface AttributeTestAnalysisContextType {
  refetchActivityLogs: () => Promise<void>;
}

const AttributeTestAnalysisContext = createContext<
  AttributeTestAnalysisContextType | undefined
>(undefined);

export function AttributeTestAnalysisProvider({
  children,
  refetchActivityLogs,
}: {
  children: ReactNode;
  refetchActivityLogs: () => Promise<void>;
}) {
  return (
    <AttributeTestAnalysisContext.Provider value={{ refetchActivityLogs }}>
      {children}
    </AttributeTestAnalysisContext.Provider>
  );
}

export function useAttributeTestAnalysisContext() {
  const context = useContext(AttributeTestAnalysisContext);
  if (!context) {
    throw new Error(
      "useAttributeTestAnalysisContext must be used within AttributeTestAnalysisProvider",
    );
  }
  return context;
}
